import React from 'react';
import Reflux from 'reflux';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab} from 'Components';
import {Tabs} from 'antd';

const TabPane = Tabs.TabPane;

import img1 from '../../assets/bank/zsbank/1.png';
import img2 from '../../assets/bank/zsbank/2.png';
import img3 from '../../assets/bank/zsbank/3.png';

class Zsbank extends Reflux.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['浙商银行'],
            button_limits_end: JSON.parse(window.localStorage.getItem('button_limits_end')),
        };
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    render() {
        const {opts} = this.state;
        return (
            <div className='dms-body'>
                <div>
                    <DmsTab options={opts} defaultKey={0}> </DmsTab>
                </div>
                <div className="dms-table-box">
                    <Tabs defaultActiveKey="1">
                        <TabPane tab="银行介绍" key="1"><img src={img1}></img></TabPane>
                        <TabPane tab="产品介绍" key="2"><img src={img2}></img></TabPane>
                        <TabPane tab="融资窗口" key="3"><img src={img3}></img></TabPane>
                    </Tabs>
                </div>
            </div>
        )
    }
};
export default withRouter(Zsbank);




// WEBPACK FOOTER //
// ./src/routes/financing/zsbank.js